import React from "react";
import {ConfirmDialog} from "primereact/confirmdialog";

/**
 * DeleteConfirmDialog - Silme onayı için ortak dialog component
 *
 * @param {Object} props
 * @param {Object} props.itemToDelete - Silinecek item (null ise dialog gizli)
 * @param {function} props.onHide - Dialog kapatma callback'i
 * @param {function} props.onConfirm - Silme onay callback'i
 * @param {string} [props.header="Silme Onayı"] - Dialog başlığı
 * @param {string} [props.message="Kaydı Silmek İstediğinize Emin misiniz?"] - Onay mesajı
 */
const DeleteConfirmDialog = (props) => {
    const {
        itemToDelete,
        onHide,
        onConfirm,
        header = "Silme Onayı",
        message = "Kaydı Silmek İstediğinize Emin misiniz?"
    } = props;

    const handleAccept = () => {
        if (itemToDelete && onConfirm) {
            onConfirm(itemToDelete.id);
        }
        onHide();
    };

    return (
        <ConfirmDialog
            visible={!!itemToDelete}
            onHide={onHide}
            header={header}
            message={message}
            icon="pi pi-exclamation-triangle"
            acceptClassName='p-button-danger'
            acceptLabel='Evet'
            rejectLabel='Hayır'
            accept={handleAccept}
            reject={onHide}
        />
    );
};

export default DeleteConfirmDialog;
